/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Win_Back_Paywall_Benefit_Event_RewardInputs */

const en_win_back_paywall_benefit_event_reward = /** @type {(inputs: Win_Back_Paywall_Benefit_Event_RewardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Special event rewards`)
};

const ar_win_back_paywall_benefit_event_reward = /** @type {(inputs: Win_Back_Paywall_Benefit_Event_RewardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مكافآت الفعاليات الخاصة`)
};

const de_win_back_paywall_benefit_event_reward = /** @type {(inputs: Win_Back_Paywall_Benefit_Event_RewardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belohnungen bei besonderen Events`)
};

const es_win_back_paywall_benefit_event_reward = /** @type {(inputs: Win_Back_Paywall_Benefit_Event_RewardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recompensas de eventos especiales`)
};

const fr_win_back_paywall_benefit_event_reward = /** @type {(inputs: Win_Back_Paywall_Benefit_Event_RewardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Récompenses des événements spéciaux`)
};

const it_win_back_paywall_benefit_event_reward = /** @type {(inputs: Win_Back_Paywall_Benefit_Event_RewardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ricompense degli eventi speciali`)
};

const ja_win_back_paywall_benefit_event_reward = /** @type {(inputs: Win_Back_Paywall_Benefit_Event_RewardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`特別イベントの報酬`)
};

const ko_win_back_paywall_benefit_event_reward = /** @type {(inputs: Win_Back_Paywall_Benefit_Event_RewardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`특별 이벤트 보상`)
};

const pt_br_win_back_paywall_benefit_event_reward = /** @type {(inputs: Win_Back_Paywall_Benefit_Event_RewardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recompensas de eventos especiais`)
};

const ru_win_back_paywall_benefit_event_reward = /** @type {(inputs: Win_Back_Paywall_Benefit_Event_RewardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Награды особых событий`)
};

const th_win_back_paywall_benefit_event_reward = /** @type {(inputs: Win_Back_Paywall_Benefit_Event_RewardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รางวัลกิจกรรมพิเศษ`)
};

const tr_win_back_paywall_benefit_event_reward = /** @type {(inputs: Win_Back_Paywall_Benefit_Event_RewardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Özel etkinlik ödülleri`)
};

const zh_cn_win_back_paywall_benefit_event_reward = /** @type {(inputs: Win_Back_Paywall_Benefit_Event_RewardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`特别活动奖励`)
};

const zh_tw_win_back_paywall_benefit_event_reward = /** @type {(inputs: Win_Back_Paywall_Benefit_Event_RewardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`特別活動獎勵`)
};

/**
* | output |
* | --- |
* | "Special event rewards" |
*
* @param {Win_Back_Paywall_Benefit_Event_RewardInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const win_back_paywall_benefit_event_reward = /** @type {((inputs?: Win_Back_Paywall_Benefit_Event_RewardInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Win_Back_Paywall_Benefit_Event_RewardInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_win_back_paywall_benefit_event_reward(inputs)
	if (locale === "ar") return ar_win_back_paywall_benefit_event_reward(inputs)
	if (locale === "de") return de_win_back_paywall_benefit_event_reward(inputs)
	if (locale === "es") return es_win_back_paywall_benefit_event_reward(inputs)
	if (locale === "fr") return fr_win_back_paywall_benefit_event_reward(inputs)
	if (locale === "it") return it_win_back_paywall_benefit_event_reward(inputs)
	if (locale === "ja") return ja_win_back_paywall_benefit_event_reward(inputs)
	if (locale === "ko") return ko_win_back_paywall_benefit_event_reward(inputs)
	if (locale === "pt_br") return pt_br_win_back_paywall_benefit_event_reward(inputs)
	if (locale === "ru") return ru_win_back_paywall_benefit_event_reward(inputs)
	if (locale === "th") return th_win_back_paywall_benefit_event_reward(inputs)
	if (locale === "tr") return tr_win_back_paywall_benefit_event_reward(inputs)
	if (locale === "zh_cn") return zh_cn_win_back_paywall_benefit_event_reward(inputs)
	return zh_tw_win_back_paywall_benefit_event_reward(inputs)
});